function Counters() {
    return (
      <>
        <div className="font-bold text-lg mb-16">Counters</div>
      </>
    );
  }
  
  export default Counters;